<template>
  <div>
    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="reports"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <!-- <h2>Courses</h2> -->
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  reports.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : reports.length
                }}
                of {{ queriedItems }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th>User name</vs-th>
          <vs-th>Email</vs-th>
          <vs-th sort-key="views">Courses Viewed</vs-th>
          <vs-th>Created Date</vs-th>
          <vs-th>Actions</vs-th>
          
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
             
              <vs-td>
                <p class="reports-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="reports-modules">{{ tr.email }}</p>
              </vs-td>

              <vs-td class="text-center">
                <p class="reports-chapters">{{ tr.views }}</p>
              </vs-td>
              <vs-td>
                <p class="reports-totalhrs">
                  {{ new Date(tr.date).toLocaleString() }}
                </p>
              </vs-td>
              
              <vs-td class="text-center">
                <feather-icon
                  class="items-center"
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="viewItem(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody> </template
        >>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moduleUsersreport from '@/store/usersReport/moduleUsersreport.js'
export default {
  components: {},
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    reports() {
      return this.$store.state.usersReport.usersReport
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.reports.length
    }
  },
  methods: {
    viewItem(item) {
      this.$router.push(`/pages/reports/users/${item._id}`).catch(() => {})
    }
  },
  created() {
    if (!moduleUsersreport.isRegistered) {
      this.$store.registerModule('usersReport', moduleUsersreport)
      moduleUsersreport.isRegistered = true
    }
    this.$store.dispatch('usersReport/fetchUsersReport')
  },
  mounted() {
    this.isMounted = true
    // this.$store.dispatch('usersReport/fetchUsersReport')
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
